import ServiceContract from "./service_contract.coffee";

$(document).on('turbolinks:load', function(){
  new ServiceContract().start_handlers()

    $('#search_company_button').on('click', function () {
        $('#search_company_modal').modal('show');
    })
});
